export const tags = {
  headerByDocId: (id: string) => `header-document-id-${id}`,
  footerByDocId: (id: string) => `footer-document-id-${id}`,
  pageBySlug: (slug: string) => `page-slug-${slug}`,
  blogBySlug: (slug: string) => `blog-slug-${slug}`,
  blogTopicBySlug: (slug: string) => `blog-topic-slug-${slug}`,
};
